// extracted by mini-css-extract-plugin
module.exports = {"hamburger":"kUE7W"};